<template>
  <section
    data-test="search-wizard-accommodation"
    class="accommodation-wizard-summary"
  >
    <translate v-if="$isDesktop" tag="p"> Accommodation </translate>
    <div v-else class="summary-header">
      <translate tag="p"> Accommodation </translate>
      <span class="electric-facet-status" :class="{ on: hasElectricFacet }">
        <img
          src="@/assets/images/electric.svg"
          width="16"
          height="21"
          loading="lazy"
          alt=""
        />
        <translate> Electric pitch </translate></span
      >
    </div>

    <div class="all-categories">
      <img
        v-if="showAllCategories"
        src="@/assets/images/category-icons/all-categories.svg"
        :alt="$t('Accommodation categories')"
        width="61"
        height="30"
      />
      <selected-categories v-else :selected-ids="selectedCategoryIdsOrAll" />
    </div>
  </section>
</template>

<script lang="ts">
import CATEGORY_MAP from '~/json/catRoot.json'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class AccommodationWizardSummary extends Vue {
  @Prop({ required: true, type: Array })
  categoryIds: string[]

  @Prop({ required: true, type: Array })
  searchFiltersFacets: string[]

  @Prop({ required: false, type: Boolean, default: false })
  isSearchResults: boolean

  get selectedCategoryIdsOrAll() {
    return this.categoryIds.length
      ? this.categoryIds
      : Object.keys(CATEGORY_MAP)
  }

  get showAllCategories() {
    return (
      this.isSearchResults && this.$isDesktop && this.categoryIds.length === 0
    )
  }

  get hasElectricFacet() {
    return this.searchFiltersFacets.includes('electric')
  }
}

export default toNative(AccommodationWizardSummary)
</script>
<style scoped>
.summary-header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  column-gap: 1em;
}
.electric-facet-status {
  display: inline-block;
  text-wrap-style: pretty;
  text-align: right;
  line-height: 0.5;
  text-wrap-style: balance;
  & span {
    font-size: var(--small);
    color: var(--colour-text-light);
  }
  & img {
    filter: grayscale(100%) brightness(150%);
  }
}
.electric-facet-status.on {
  & span {
    color: var(--colour-text-default);
  }
  & img {
    filter: grayscale(0%) brightness(100%);
  }
}
</style>
